import { useEffect } from 'react';

import { startPushChannel } from '~services/pushChannel';

/**
 * Opens the OneService push stream for the lifetime of the mounting component.
 * Mount once in the authenticated shell so the tab starts receiving server
 * pushes (heartbeats today; operation/entity updates as the backend adds them).
 * No-op under HTTP-only transport.
 */
export function usePushChannel(): void {
  useEffect(() => {
    const stop = startPushChannel();
    return () => stop();
  }, []);
}
